import { Link } from "react-router-dom";
import { BRAND } from "@/lib/brand";
import { useStories } from "@/hooks/useCatalogue";
import PageIntro from "@/components/PageIntro";

export default function Stories() {
  const { data: stories = [] } = useStories();
  return (
    <div>
      <PageIntro
        eyebrow="Member experiences"
        title="Stories from the community"
        description="Voluntary, consented stories shared by members. A member's private name, address and journal never appear here automatically."
      />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-24">
        {stories.length === 0 ? (
          <div className="border border-dashed border-forest/25 bg-cream/60 p-14 text-center">
            <p className="font-serif text-2xl text-forest">No stories yet</p>
            <p className="mt-3 text-charcoal/70 max-w-md mx-auto">
              Be among the first to share how a ritual fits into your everyday skincare.
            </p>
            <Link to="/join" className="mt-6 inline-flex btn btn-primary">
              {BRAND.joinCta}
            </Link>
          </div>
        ) : (
          <div className="grid gap-6 md:grid-cols-3">
            {stories.map((s) => (
              <div key={s.story_id} className="border border-forest/15 bg-cream p-6">
                <p className="text-sm text-charcoal/80 leading-relaxed">"{s.body}"</p>
                <p className="mt-4 text-[10px] uppercase tracking-[0.24em] text-moss">{s.display_name}</p>
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
